export default __webpack_public_path__ + "static/media/destiny_spinner.30fa89e9.svg";